import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerBankElement: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: theme.spacing(4),
    },
    firstElement: {
      paddingTop: 0,
    },
    label: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 500,
      fontSize: 14,
      color: '#677685',
    },
    referenceData: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: 700,
      fontSize: 16,
      color: theme.oysterTheme.pine,
      display: 'flex',
      textAlign: 'right',
    },
    copyButton: {
      color: theme.oysterTheme.oyster,
      marginLeft: 10,
      padding: 0,
    },
  }),
);

export default useStyles;
